import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const profileCardStyles = {
	profileSection: {
		minWidth: 'max-content',
		width: '100%',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.dark3}`,
		padding: '8px 12px',

		backgroundColor: 'colors.dark5',
		'@media (min-width: 1300px)': {
			backgroundColor: colorPalette.dark3,
			border: `1px solid ${colorPalette.dark1}`,
		},
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	profileDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	avatar: {
		flexShrink: 0,

		width: '48px',
		height: '48px',
		minHeight: '48px',
		borderRadius: '50%',
		border: `1px solid ${colorPalette.dark1}`,

		objectFit: 'cover',
		overflow: 'hidden',

		'& img': {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},
	},
	buyCreditsButton: {
		width: '100%',
		padding: '8px',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.dark1}`,

		backgroundColor: 'colors.dark3',

		textTransform: 'none',
	},
};
